import PropTypes from 'prop-types';

const AiIcon = ({ width, height, className }) => (
  <svg
    className={`${className} tw-rounded-full`}
    width={width}
    height={height}
    viewBox="16 12 64 64"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    {/* <circle cx="48" cy="44" r="32" fill="white" /> */}
    <circle cx="48" cy="44" r="32" fill="#E67D2D" fillOpacity="0.3" />
    <g>
      <path
        d="M80 43.9999C80 61.6731 65.6733 75.9998 48.0001 75.9998C30.3269 75.9998 16 61.6731 16 43.9999C16 26.3267 30.3269 12 48.0001 12C65.6733 12 80 26.3267 80 43.9999Z"
        fill="#E67D2D"
      />
      <path
        d="M47.9985 68.8261C34.1241 68.8261 22.8765 57.7119 22.8765 43.9997C22.8765 30.2877 34.1241 19.1735 47.9985 19.1735C61.8728 19.1735 73.1236 30.2877 73.1236 43.9997C73.1236 57.7119 61.8728 68.8261 47.9985 68.8261ZM47.9985 18.6583C33.4785 18.6583 21.7094 30.0046 21.7094 43.9997C21.7094 57.995 33.4785 69.3413 47.9985 69.3413C62.5184 69.3413 74.2908 57.995 74.2908 43.9997C74.2908 30.0046 62.5184 18.6583 47.9985 18.6583Z"
        fill="white"
      />
      <path
        d="M47.9985 66.3297C35.9303 66.3297 26.1455 56.3318 26.1455 43.9997C26.1455 31.6677 35.9303 21.6697 47.9985 21.6697C60.0698 21.6697 69.8547 31.6677 69.8547 43.9997C69.8547 56.3318 60.0698 66.3297 47.9985 66.3297ZM47.9985 21.2055C34.9382 21.2055 24.352 31.4132 24.352 43.9997C24.352 56.5862 34.9382 66.7939 47.9985 66.7939C61.0619 66.7939 71.6482 56.5862 71.6482 43.9997C71.6482 31.4132 61.0619 21.2055 47.9985 21.2055Z"
        fill="white"
      />
      <path
        d="M47.9985 63.2036C38.1215 63.2036 30.1111 54.608 30.1111 43.9995C30.1111 33.391 38.1215 24.7955 47.9985 24.7955C57.8788 24.7955 65.8892 33.391 65.8892 43.9995C65.8892 54.608 57.8788 63.2036 47.9985 63.2036ZM47.9985 24.398C36.7668 24.398 27.6624 33.1747 27.6624 43.9995C27.6624 54.8242 36.7668 63.6011 47.9985 63.6011C59.2303 63.6011 68.3379 54.8242 68.3379 43.9995C68.3379 33.1747 59.2303 24.398 47.9985 24.398Z"
        fill="white"
      />
      <path
        d="M59.0173 49.9717C58.8932 49.9717 58.7597 49.9559 58.6261 49.9559C56.6705 49.8509 55.6147 48.6584 55.6147 46.4832C55.6147 46.2543 55.6306 46.0253 55.6496 45.7868H58.1428C58.111 45.9616 58.111 46.1494 58.111 46.3147C58.111 47.3991 58.6389 47.8856 59.1381 47.8856C59.6056 47.8856 60.0475 47.4786 60.0475 46.7377C60.0475 44.8328 55.7673 44.712 55.7673 41.0073C55.7673 39.5858 57.0679 38.0276 59.0968 38.0276C60.9984 38.0276 62.6584 39.1024 62.5534 41.7195H60.0475C60.0571 41.5956 60.0571 41.4588 60.0571 41.3572C60.0571 40.3904 59.5897 40.0118 59.1222 40.0118C58.6801 40.0118 58.2605 40.3426 58.2605 40.8832C58.2605 42.804 62.4358 42.5749 62.5534 46.1494C62.6584 49.0686 60.9825 49.9717 59.0173 49.9717ZM55.3635 46.2128C55.3635 48.9541 54.0343 49.7842 51.8845 49.7842C49.385 49.7842 48.0717 48.8333 48.0717 46.5627V38.2152H50.8065V46.8012C50.8065 47.4563 51.2486 47.7743 51.6873 47.7743C52.1389 47.7743 52.6063 47.4277 52.6063 46.6867V38.2152H55.3635V46.2128ZM47.6996 49.6632H41.7403V38.3361H44.4942V47.3926H47.6996V49.6632ZM37.6286 45.2907C37.3583 45.2907 37.0848 45.2749 36.8176 45.2654V49.6632H34.0765V38.3361H37.2978C40.5033 38.3361 41.3682 39.5318 41.3682 41.7832C41.3682 44.7438 39.6701 45.2907 37.6286 45.2907ZM48.0017 27.5685C38.926 27.5685 31.5706 34.9238 31.5706 43.9996C31.5706 53.0753 38.926 60.4307 48.0017 60.4307C57.0743 60.4307 64.4296 53.0753 64.4296 43.9996C64.4296 34.9238 57.0743 27.5685 48.0017 27.5685Z"
        fill="white"
      />
      <path
        d="M38.6017 41.4365C38.6017 42.629 38.4935 43.2332 36.8176 43.2332V40.3615C36.9798 40.3457 37.1293 40.3362 37.2851 40.3362C38.0801 40.3362 38.6017 40.635 38.6017 41.4365Z"
        fill="white"
      />
      <rect x="32.5925" y="37.4812" width="30.8148" height="13.037" rx="3.55556" fill="white" />
      <path
        d="M39.6611 51.8145L42.8824 36.8811H47.6611L50.8824 51.8145H46.8717L46.3597 48.9985H43.5864L43.0957 51.8145H39.6611ZM44.0984 46.0118H45.8264L44.9304 40.6145L44.0984 46.0118ZM51.4682 51.8145V36.8811H55.4789V51.8145H51.4682Z"
        fill="#E67D2D"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_24_557"
        x="0"
        y="0"
        width="96"
        height="95.9998"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="4" />
        <feGaussianBlur stdDeviation="8" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_24_557" />
        <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_24_557" result="shape" />
      </filter>
    </defs>
  </svg>
);

AiIcon.propTypes = {
  width: PropTypes.number.isRequired,
  height: PropTypes.number.isRequired,
  className: PropTypes.string,
};

AiIcon.defaultProps = {
  className: '',
};

export default AiIcon;
